import React, {useState} from 'react';
import {Trans} from '@lingui/react';
import {FormGroup} from 'react-bootstrap';
import {UseFormSetValue} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import TimeoutSlider from 'shared/ui/Slider/TimeoutSlider';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {isTranslate} from 'shared/lib/lang';

import styles from './RequestTimeout.module.scss';

interface IRequestTimeoutProps {
    item?: IHttpMonitorOutput,
    setValue: UseFormSetValue<any>;
}

const RequestTimeout: React.FC<IRequestTimeoutProps> = ({item, setValue}) => {
    const httpRequestTimeout = item?.http_request_timeout ?? 30;
    const [httpTimeout, changeTimeout] = useState(httpRequestTimeout);

    return (

        <FormGroup className={styles.formGroup}>
            <label
                htmlFor="requestTimeout"
                className={styles.label}
            >
                <Trans id="RequestTimeout.title" message="Таймаут запроса"/>, {httpTimeout} {t`сек`}.
            </label>
            <TimeoutSlider
                name="http_request_timeout"
                setValue={setValue}
                defaultValue={isTranslate() ? 15 : httpRequestTimeout}
                onChange={(value) => {
                    changeTimeout(value);
                }}
            />
        </FormGroup>
    );
};

export default RequestTimeout;